var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerritoryHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 60,
    fill: "#F3E6F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.6023 64.9409C95.8333 67.5691 95.8333 70.8451 95.8333 75C95.8333 83.6118 95.8333 88.4478 93.7762 91.5652L81.3773 79.1663L95.6023 64.9409Z",
    fill: "#870091"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5667 93.7752L79.1675 81.376L64.9409 95.6023C67.5691 95.8333 70.8451 95.8333 75 95.8333C83.6132 95.8333 88.4494 95.8333 91.5667 93.7752Z",
    fill: "#870091"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 54.1667C84.8209 54.1667 89.7314 54.1667 92.7823 57.2176C93.8321 58.2674 94.5206 59.5372 94.9723 61.1515L61.1514 94.9723C59.5372 94.5206 58.2673 93.8321 57.2176 92.7824C54.1666 89.7314 54.1666 84.8209 54.1666 75C54.1666 65.1791 54.1666 60.2686 57.2176 57.2176C60.2686 54.1667 65.179 54.1667 75 54.1667ZM61.4583 68.2444C61.4583 71.9629 63.7855 76.302 67.4166 77.8537C68.263 78.2154 69.2369 78.2154 70.0834 77.8537C73.7144 76.302 76.0416 71.9629 76.0416 68.2444C76.0416 64.4966 72.777 61.4583 68.75 61.4583C64.7229 61.4583 61.4583 64.4966 61.4583 68.2444Z",
    fill: "#870091"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.875 68.75C71.875 70.4759 70.4759 71.875 68.75 71.875C67.0241 71.875 65.625 70.4759 65.625 68.75C65.625 67.0241 67.0241 65.625 68.75 65.625C70.4759 65.625 71.875 67.0241 71.875 68.75Z",
    fill: "#870091"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerritoryHover);
export default __webpack_public_path__ + "static/media/Territory-hover.ed23975957b7248a6a2492d8a1a9e88f.svg";
export { ForwardRef as ReactComponent };